import * as React from 'react';
import IAgreementContainer from './IAgreementContainer';
import Agreement from '@market/components/Agreement/Agreement';
import RiskNotice from '@market/components/RiskNotice/RiskNotice';
import * as Agreements from './agreements';
import Notice from '@appComponents/Notice/Notice';

const AgreementContainer: React.SFC<IAgreementContainer> = (props) => {


  const getAgreement = () => {
    switch (props.action) {
      case 'BuyOrder':
        return Agreements.agreementsForOrderBuy;
      case 'SellOrder':
        return Agreements.agreementsForOrderSell;
      case 'SellTrade':
        return Agreements.agreementsForTradeSell;
      case 'BuyTrade':
        return Agreements.agreementsForTradeBuy;
    }

    return Agreements.agreementsForOrderBuy;
  };

  const getRiskWarnings = () => {
    switch (props.action) {
      case 'BuyOrder':
        return Agreements.riskWarningsForOrderBuy;
      case 'SellOrder':
        return Agreements.riskWarningsForOrderSell;
      case 'SellTrade':
        return Agreements.riskWarningsForTradeSell;
      case 'BuyTrade':
        return Agreements.riskWarningsForTradeBuy;
    }

    return Agreements.riskWarningsForOrderBuy;
  };

  return (
    <div>
      <Agreement
        checks={props.checks}
        updateState={props.updateState}
        agreements={getAgreement()}
        riskWarnings={getRiskWarnings()}
        documentData={props.documentData}
      />
      <Notice>By clicking Next you accept all agreements above.</Notice>
    </div>
  );
};

export default AgreementContainer;
